import { ReceiverService } from "@/common/api.service";
import {
  GET_ALLBENEFICIARY_LIST,
  UPDATE_BENEFICIARY,
  GET_BENEFICIARY_DETAILS,
  GET_BENEFICIARY_RELATIONSHIPS,
  GET_LINKED_REMITTERS,
  BLOCK_RECEIVER_RELATIONSHIP,
  UNBLOCK_RECEIVER_RELATIONSHIP,
  BLOCK_RECEIVER_MOMO,
  UNBLOCK_RECEIVER_MOMO,
  BLOCK_RECEIVER_BANK,
  UNBLOCK_RECEIVER_BANK,
  GET_RECEIVER_LIST,
  GET_RECEIVER_RISK_BATCH,
  GET_RECEIVER_RISK_EVIDENCE,
  GET_RECEIVER_REMITTER_SIGNALS,
} from "./actions.type";
import { SET_ERROR, ISLOADING } from "./mutations.type";
const state = {
  errors: null,
};

const getters = {
  //
};

const actions = {
  // get beneficiary-list
  async [GET_ALLBENEFICIARY_LIST](context, payload) {
    ReceiverService.init();
    ReceiverService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ReceiverService.get(`beneficiary/listing/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // get de-duplicated receiver list (one row per receiver, with AML columns)
  async [GET_RECEIVER_LIST](context, payload) {
    ReceiverService.init();
    ReceiverService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ReceiverService.get(`beneficiary/receivers${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // receiver linked-risk summaries for a bounded batch of receivers
  async [GET_RECEIVER_RISK_BATCH](context, beneficiaryIds) {
    ReceiverService.init();
    ReceiverService.setHeader();
    return new Promise((resolve) => {
      ReceiverService.post(`beneficiary/linked-risk/batch`, { beneficiaryIds })
        .then((data) => resolve(data))
        .catch(({ response }) => resolve(response));
    });
  },
  // receiver linked-risk evidence (factors + linked remitters + shared identities)
  async [GET_RECEIVER_RISK_EVIDENCE](context, beneficiaryid) {
    ReceiverService.init();
    ReceiverService.setHeader();
    return new Promise((resolve) => {
      ReceiverService.get(`beneficiary/linked-risk/${beneficiaryid}/evidence`)
        .then((data) => resolve(data))
        .catch(({ response }) => resolve(response));
    });
  },
  // per-remitter link signals for a receiver's Linked Remitters list (keyed by customer id)
  async [GET_RECEIVER_REMITTER_SIGNALS](context, beneficiaryid) {
    ReceiverService.init();
    ReceiverService.setHeader();
    return new Promise((resolve) => {
      ReceiverService.get(`beneficiary/linked-risk/${beneficiaryid}/remitter-signals`)
        .then((data) => resolve(data))
        .catch(({ response }) => resolve(response));
    });
  },
  // get beneficiary/relationships
  async [GET_BENEFICIARY_RELATIONSHIPS](context) {
    ReceiverService.init();
    ReceiverService.setHeader();
    const data = await ReceiverService.get("beneficiary/relationships");
    context.commit(ISLOADING, false);
    return data;
  },

  // get linked remitters
  async [GET_LINKED_REMITTERS](context, payload) {
    ReceiverService.init();
    ReceiverService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ReceiverService.get(
        `beneficiary/remitterList/${payload.beneficiaryid}/${payload.query}`,
      )
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // get beneficiary basic details
  async [GET_BENEFICIARY_DETAILS](context, payload) {
    ReceiverService.init();
    ReceiverService.setHeader();
    return new Promise((resolve) => {
      ReceiverService.get(
        `beneficiary/basicInfo/${payload.beneficiary_id}/${payload.customer_id}`,
      )
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // update beneficiary basic details
  async [UPDATE_BENEFICIARY](context, payload) {
    ReceiverService.init();
    ReceiverService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ReceiverService.put(
        `beneficiary/basicInfo/${payload.beneficiary_id}/${payload.customer_id}`,
        payload,
      )
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // ── Beneficiary blacklist (block/unblock) ──────────────────────────
  // L1 — block beneficiary relationship
  async [BLOCK_RECEIVER_RELATIONSHIP](context, payload) {
    ReceiverService.init();
    ReceiverService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ReceiverService.put("beneficiary/block/relationship", payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // L1 — unblock beneficiary relationship
  async [UNBLOCK_RECEIVER_RELATIONSHIP](context, payload) {
    ReceiverService.init();
    ReceiverService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ReceiverService.put("beneficiary/unblock/relationship", payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // L2 — block mobile money record
  async [BLOCK_RECEIVER_MOMO](context, payload) {
    ReceiverService.init();
    ReceiverService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ReceiverService.put(`beneficiary/block/momo/${payload.id}`, {
        reason: payload.reason,
      })
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // L2 — unblock mobile money record
  async [UNBLOCK_RECEIVER_MOMO](context, payload) {
    ReceiverService.init();
    ReceiverService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ReceiverService.put(`beneficiary/unblock/momo/${payload.id}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // L3 — block bank account record
  async [BLOCK_RECEIVER_BANK](context, payload) {
    ReceiverService.init();
    ReceiverService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ReceiverService.put(`beneficiary/block/bank/${payload.id}`, {
        reason: payload.reason,
      })
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
  // L3 — unblock bank account record
  async [UNBLOCK_RECEIVER_BANK](context, payload) {
    ReceiverService.init();
    ReceiverService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      ReceiverService.put(`beneficiary/unblock/bank/${payload.id}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },
};
const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [ISLOADING](state, loading) {
    state.isLoading = loading;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
